import { unionLoggedPlayhead, nextPath, STANDARD_CUT, SMALL_CUT, COLORS } from "@app/brand/mark";
// COLORS kept for brassOnDark next fill (static dark brass)

/**
 * Timeline T mark. Variants: mono | brass | reversed | porcelainOnMidnight
 */
export default function BrandMark({
  size = 34,
  variant = "brass",
  cut = "standard",
  className = "",
  title = "TymLogr",
}) {
  const geom = cut === "small" ? SMALL_CUT : STANDARD_CUT;
  const body = unionLoggedPlayhead(geom);
  const next = nextPath(geom);

  // Body uses the flipping ink CSS var so AuthShell stays visible in dark mode (audit-155 R1).
  const ink = "var(--brand-midnight)";
  let bodyFill = ink;
  let nextFill = ink;
  if (variant === "brass") {
    bodyFill = ink;
    nextFill = "var(--brand-brass)";
  } else if (variant === "reversed" || variant === "porcelainOnMidnight") {
    // Light-on-dark variants sit on grounds that stay dark in both themes (sidebar,
    // headers, email), so they need a token that stays light in both themes.
    // --brand-porcelain flips to the dark page ground (#0B1226) in .dark — never use it here (audit-156).
    bodyFill = "var(--brand-sidebar-ink)";
    nextFill = variant === "porcelainOnMidnight" ? "var(--brand-brass)" : "var(--brand-sidebar-ink)";
  } else if (variant === "brassOnDark") {
    bodyFill = "var(--brand-sidebar-ink)";
    nextFill = COLORS.brassDark;
  }

  return (
    <svg
      viewBox="0 0 256 256"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path d={body} fill={bodyFill} />
      <path d={next} fill={nextFill} />
    </svg>
  );
}
